import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isTimeInput(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.TIME_INPUT && typeof label === 'string' && typeof value === 'string';
}
export function formatTimeInput(submission) {
  if (isTimeInput(submission) && submission.value) {
    return {
      label: submission.field.view.label,
      value: submission.value
    };
  }
  return undefined;
}
//# sourceMappingURL=time-input-preview.js.map